module.exports = __webpack_public_path__ + "static/media/D4.30a9f558.mp3";